// Generated by GitHub Copilot
import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import { ConfigSwitch } from '#components/primitives/forms/config-switch.tsx'
import { SsoUnavailableHint } from './sso-unavailable-hint.tsx'

interface MemberSignInRequirementsProps {
  mfaRequired: boolean
  ssoRequired: boolean
  /** Offers the SSO requirement; off while the company has no SSO provider connected. */
  showSso: boolean
  disabled?: boolean
  /** Set once the backend refused to switch the SSO requirement on: no tenant is connected. */
  ssoUnavailable?: boolean
  onMfaRequiredChange: (required: boolean) => void
  onSsoRequiredChange: (required: boolean) => void
}

/** One member's sign-in requirements in this company: an MFA code and, when offered, a single sign-on. */
export function MemberSignInRequirements({ mfaRequired, ssoRequired, showSso, disabled = false, ssoUnavailable = false, onMfaRequiredChange, onSsoRequiredChange }: MemberSignInRequirementsProps) {
  const { t } = useTranslation('settings')
  const baseId = useId()

  return (
    <div className="d-flex flex-column gap-2 mt-3">
      <ConfigSwitch
        id={`${baseId}-mfa`}
        label={t('signInRequirements.member.mfa')}
        description={t('signInRequirements.member.mfaHint')}
        checked={mfaRequired}
        disabled={disabled}
        onChange={onMfaRequiredChange}
      />
      {showSso && (
        <ConfigSwitch
          id={`${baseId}-sso`}
          label={t('signInRequirements.member.sso')}
          description={
            <>
              {t('signInRequirements.member.ssoHint')}
              {ssoUnavailable && <SsoUnavailableHint />}
            </>
          }
          checked={ssoRequired}
          disabled={disabled}
          onChange={onSsoRequiredChange}
        />
      )}
    </div>
  )
}
